import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Input(theme) {
  return {
    MuiTextField: {
      defaultProps: {
        variant: "filled",
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '& svg': { color: theme.palette.text.disabled },
          },
        },
        input: {
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56],
          },
        },
      },
    },
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius * 1.5,
          backgroundColor: alpha(theme.palette.grey[500], 0.08),
          border: `1px solid ${alpha(theme.palette.grey[500], 0.18)}`,
          transition: theme.transitions.create(
            ["background-color", "border-color", "box-shadow"],
            {
              duration: theme.transitions.duration.shorter,
            }
          ),
          '&:hover': {
            backgroundColor: alpha(theme.palette.grey[500], 0.12),
          },
          '&.Mui-focused': {
            backgroundColor: alpha(theme.palette.primary.main, 0.06),
            borderColor: alpha(theme.palette.primary.main, 0.45),
            boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.10)}`,
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
            borderColor: theme.palette.action.disabledBackground,
          },
        },
        input: {
          paddingTop: 18,
          paddingBottom: 18,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey[500_32],
          },
          '&.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.disabledBackground,
            },
          },
        },
      },
    },
  };
}
